import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { targetId: String }

  connect() {
    this.target = document.getElementById(this.targetIdValue)
    if (!this.target) return

    this.lastScrollY = window.scrollY
    this.hasPassedTarget = false
    this.queued = false
    this.updateVisibility = this.updateVisibility.bind(this)
    this.onScroll = this.onScroll.bind(this)

    this.updateVisibility()
    window.addEventListener("scroll", this.onScroll, { passive: true })
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
  }

  onScroll() {
    if (this.queued) return

    this.queued = true
    requestAnimationFrame(() => {
      this.queued = false
      this.updateVisibility()
    })
  }

  updateVisibility() {
    const scrollY = window.scrollY
    const scrollingUp = scrollY < this.lastScrollY
    const targetTop = this.target.getBoundingClientRect().top
    const threshold = window.innerHeight * 0.35

    if (targetTop <= threshold) {
      this.hasPassedTarget = true
    } else if (scrollingUp) {
      this.hasPassedTarget = false
    }

    this.element.classList.toggle("hidden", this.hasPassedTarget)
    this.lastScrollY = scrollY
  }
}
